// [EDITED: KPI Task - Mahesh Sharma]
import React, { useState, useRef, useEffect, useMemo } from 'react'; // [EDITED: KPI Task - Mahesh Sharma]
import moment from 'moment-timezone'; // [EDITED: KPI Task - Mahesh Sharma]
import { formatFYWeekLabel } from '../utils/fyWeekUtils'; // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Returns current ISO week code (e.g. '2026-W37') in IST
 */
function getCurrentIsoWeek() { // [EDITED: KPI Task - Mahesh Sharma]
  const now = moment().tz('Asia/Kolkata'); // [EDITED: KPI Task - Mahesh Sharma]
  return `${now.isoWeekYear()}-W${String(now.isoWeek()).padStart(2, '0')}`; // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Helper to extract a Moment object representing the start of a week from any week format
 */
function getWeekMoment(val) { // [EDITED: KPI Task - Mahesh Sharma]
  const effectiveVal = val || getCurrentIsoWeek(); // [EDITED: KPI Task - Mahesh Sharma]
  if (typeof effectiveVal === 'string' && effectiveVal.includes('W')) { // [EDITED: KPI Task - Mahesh Sharma]
    const parts = effectiveVal.split('W'); // [EDITED: KPI Task - Mahesh Sharma]
    const year = parseInt(parts[0].replace(/[^0-9]/g, ''), 10); // [EDITED: KPI Task - Mahesh Sharma]
    const weekNo = parseInt(parts[1], 10); // [EDITED: KPI Task - Mahesh Sharma]
    return moment().tz('Asia/Kolkata').isoWeekYear(year).isoWeek(weekNo).startOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]
  return moment(effectiveVal).tz('Asia/Kolkata'); // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]

/**
 * FYWeekPicker Component
 * Unified calendar week selector that displays Financial Year week text
 * and provides a custom interactive calendar dropdown WITHOUT any confusing original week number column.
 * Always highlights and defaults to the current week.
 */
export default function FYWeekPicker({ // [EDITED: KPI Task - Mahesh Sharma]
  value, // [EDITED: KPI Task - Mahesh Sharma]
  onChange, // [EDITED: KPI Task - Mahesh Sharma]
  size = "md", // [EDITED: KPI Task - Mahesh Sharma]
  style = {}, // [EDITED: KPI Task - Mahesh Sharma]
  className = "", // [EDITED: KPI Task - Mahesh Sharma]
  placeholder = "Select Week from Calendar..." // [EDITED: KPI Task - Mahesh Sharma]
}) { // [EDITED: KPI Task - Mahesh Sharma]
  const [isOpen, setIsOpen] = useState(false); // [EDITED: KPI Task - Mahesh Sharma]
  const [hoveredWeek, setHoveredWeek] = useState(null); // [EDITED: KPI Task - Mahesh Sharma]
  const containerRef = useRef(null); // [EDITED: KPI Task - Mahesh Sharma]

  // ViewDate tracks the month currently viewed in the calendar (defaults to selected week or current week) // [EDITED: KPI Task - Mahesh Sharma]
  const [viewDate, setViewDate] = useState(() => getWeekMoment(value).startOf('month')); // [EDITED: KPI Task - Mahesh Sharma]

  // Synchronize viewDate when value prop changes // [EDITED: KPI Task - Mahesh Sharma]
  useEffect(() => { // [EDITED: KPI Task - Mahesh Sharma]
    if (value) { // [EDITED: KPI Task - Mahesh Sharma]
      setViewDate(getWeekMoment(value).startOf('month')); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }, [value]); // [EDITED: KPI Task - Mahesh Sharma]

  // Close calendar on outside click or ESC // [EDITED: KPI Task - Mahesh Sharma]
  useEffect(() => { // [EDITED: KPI Task - Mahesh Sharma]
    const handleClickOutside = (e) => { // [EDITED: KPI Task - Mahesh Sharma]
      if (containerRef.current && !containerRef.current.contains(e.target)) { // [EDITED: KPI Task - Mahesh Sharma]
        setIsOpen(false); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]
    }; // [EDITED: KPI Task - Mahesh Sharma]
    const handleKeyDown = (e) => { // [EDITED: KPI Task - Mahesh Sharma]
      if (e.key === 'Escape') setIsOpen(false); // [EDITED: KPI Task - Mahesh Sharma]
    }; // [EDITED: KPI Task - Mahesh Sharma]

    if (isOpen) { // [EDITED: KPI Task - Mahesh Sharma]
      document.addEventListener('mousedown', handleClickOutside); // [EDITED: KPI Task - Mahesh Sharma]
      document.addEventListener('keydown', handleKeyDown); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
    return () => { // [EDITED: KPI Task - Mahesh Sharma]
      document.removeEventListener('mousedown', handleClickOutside); // [EDITED: KPI Task - Mahesh Sharma]
      document.removeEventListener('keydown', handleKeyDown); // [EDITED: KPI Task - Mahesh Sharma]
    }; // [EDITED: KPI Task - Mahesh Sharma]
  }, [isOpen]); // [EDITED: KPI Task - Mahesh Sharma]

  const handleToggle = () => { // [EDITED: KPI Task - Mahesh Sharma]
    if (!isOpen) { // [EDITED: KPI Task - Mahesh Sharma]
      // When opening, navigate directly to the selected week's month (or current week's month) // [EDITED: KPI Task - Mahesh Sharma]
      setViewDate(getWeekMoment(value || getCurrentIsoWeek()).startOf('month')); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
    setIsOpen(!isOpen); // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const handleSelectWeek = (isoWeekString) => { // [EDITED: KPI Task - Mahesh Sharma]
    if (typeof onChange === 'function') { // [EDITED: KPI Task - Mahesh Sharma]
      const customEvent = { // [EDITED: KPI Task - Mahesh Sharma]
        target: { value: isoWeekString }, // [EDITED: KPI Task - Mahesh Sharma]
        currentTarget: { value: isoWeekString }, // [EDITED: KPI Task - Mahesh Sharma]
        value: isoWeekString // [EDITED: KPI Task - Mahesh Sharma]
      }; // [EDITED: KPI Task - Mahesh Sharma]
      try { // [EDITED: KPI Task - Mahesh Sharma]
        onChange(isoWeekString); // [EDITED: KPI Task - Mahesh Sharma]
      } catch (err) { // [EDITED: KPI Task - Mahesh Sharma]
        onChange(customEvent); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
    setIsOpen(false); // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const handlePrevMonth = (e) => { // [EDITED: KPI Task - Mahesh Sharma]
    e.stopPropagation(); // [EDITED: KPI Task - Mahesh Sharma]
    setViewDate((prev) => prev.clone().subtract(1, 'month')); // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const handleNextMonth = (e) => { // [EDITED: KPI Task - Mahesh Sharma]
    e.stopPropagation(); // [EDITED: KPI Task - Mahesh Sharma]
    setViewDate((prev) => prev.clone().add(1, 'month')); // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  // Calculate current selected week's ISO string for exact matching (defaults to current week if none specified) // [EDITED: KPI Task - Mahesh Sharma]
  const currentSelectedIso = useMemo(() => { // [EDITED: KPI Task - Mahesh Sharma]
    const effectiveVal = value || getCurrentIsoWeek(); // [EDITED: KPI Task - Mahesh Sharma]
    if (typeof effectiveVal === 'string' && effectiveVal.includes('W')) { // [EDITED: KPI Task - Mahesh Sharma]
      const parts = effectiveVal.split('W'); // [EDITED: KPI Task - Mahesh Sharma]
      const year = parseInt(parts[0].replace(/[^0-9]/g, ''), 10); // [EDITED: KPI Task - Mahesh Sharma]
      const weekNo = parseInt(parts[1], 10); // [EDITED: KPI Task - Mahesh Sharma]
      return `${year}-W${String(weekNo).padStart(2, '0')}`; // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
    const m = moment(effectiveVal); // [EDITED: KPI Task - Mahesh Sharma]
    return `${m.isoWeekYear()}-W${String(m.isoWeek()).padStart(2, '0')}`; // [EDITED: KPI Task - Mahesh Sharma]
  }, [value]); // [EDITED: KPI Task - Mahesh Sharma]

  // Build the calendar weeks matrix for the viewing month // [EDITED: KPI Task - Mahesh Sharma]
  const calendarWeeks = useMemo(() => { // [EDITED: KPI Task - Mahesh Sharma]
    const startOfMonth = viewDate.clone().startOf('month'); // [EDITED: KPI Task - Mahesh Sharma]
    const endOfMonth = viewDate.clone().endOf('month'); // [EDITED: KPI Task - Mahesh Sharma]
    
    // Grid starts on Monday of the first week and ends on Sunday of the last week // [EDITED: KPI Task - Mahesh Sharma]
    const startGrid = startOfMonth.clone().startOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
    const endGrid = endOfMonth.clone().endOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]

    const weeks = []; // [EDITED: KPI Task - Mahesh Sharma]
    let currentDay = startGrid.clone(); // [EDITED: KPI Task - Mahesh Sharma]

    while (currentDay.isBefore(endGrid)) { // [EDITED: KPI Task - Mahesh Sharma]
      const weekMonday = currentDay.clone(); // [EDITED: KPI Task - Mahesh Sharma]
      const isoWeekCode = `${weekMonday.isoWeekYear()}-W${String(weekMonday.isoWeek()).padStart(2, '0')}`; // [EDITED: KPI Task - Mahesh Sharma]
      const days = []; // [EDITED: KPI Task - Mahesh Sharma]

      for (let i = 0; i < 7; i++) { // [EDITED: KPI Task - Mahesh Sharma]
        days.push({ // [EDITED: KPI Task - Mahesh Sharma]
          date: currentDay.clone(), // [EDITED: KPI Task - Mahesh Sharma]
          dayNumber: currentDay.date(), // [EDITED: KPI Task - Mahesh Sharma]
          isCurrentMonth: currentDay.month() === viewDate.month(), // [EDITED: KPI Task - Mahesh Sharma]
          isToday: currentDay.isSame(moment().tz('Asia/Kolkata'), 'day') // [EDITED: KPI Task - Mahesh Sharma]
        }); // [EDITED: KPI Task - Mahesh Sharma]
        currentDay.add(1, 'day'); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]

      weeks.push({ // [EDITED: KPI Task - Mahesh Sharma]
        isoWeekCode, // [EDITED: KPI Task - Mahesh Sharma]
        days // [EDITED: KPI Task - Mahesh Sharma]
      }); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    return weeks; // [EDITED: KPI Task - Mahesh Sharma]
  }, [viewDate]); // [EDITED: KPI Task - Mahesh Sharma]

  const displayText = value ? formatFYWeekLabel(value) : placeholder; // [EDITED: KPI Task - Mahesh Sharma]

  return ( // [EDITED: KPI Task - Mahesh Sharma]
    <div // [EDITED: KPI Task - Mahesh Sharma]
      ref={containerRef} // [EDITED: KPI Task - Mahesh Sharma]
      className={`fy-week-picker position-relative d-inline-block ${className}`} // [EDITED: KPI Task - Mahesh Sharma]
      style={{ userSelect: 'none', ...style }} // [EDITED: KPI Task - Mahesh Sharma]
    >
      {/* Clickable Trigger Box */}
      <div // [EDITED: KPI Task - Mahesh Sharma]
        onClick={handleToggle} // [EDITED: KPI Task - Mahesh Sharma]
        style={{ // [EDITED: KPI Task - Mahesh Sharma]
          cursor: 'pointer', // [EDITED: KPI Task - Mahesh Sharma]
          border: isOpen ? '1.5px solid #16a34a' : '1px solid #ced4da', // [EDITED: KPI Task - Mahesh Sharma]
          borderRadius: '6px', // [EDITED: KPI Task - Mahesh Sharma]
          backgroundColor: '#fff', // [EDITED: KPI Task - Mahesh Sharma]
          padding: size === 'sm' ? '0.35rem 0.65rem' : '0.45rem 0.85rem', // [EDITED: KPI Task - Mahesh Sharma]
          minWidth: '290px', // [EDITED: KPI Task - Mahesh Sharma]
          display: 'flex', // [EDITED: KPI Task - Mahesh Sharma]
          alignItems: 'center', // [EDITED: KPI Task - Mahesh Sharma]
          justifyContent: 'space-between', // [EDITED: KPI Task - Mahesh Sharma]
          boxShadow: isOpen ? '0 0 0 3px rgba(22, 163, 74, 0.15)' : '0 1px 3px rgba(0,0,0,0.04)', // [EDITED: KPI Task - Mahesh Sharma]
          transition: 'all 0.15s ease-in-out' // [EDITED: KPI Task - Mahesh Sharma]
        }} // [EDITED: KPI Task - Mahesh Sharma]
        title="Click to select week from calendar" // [EDITED: KPI Task - Mahesh Sharma]
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}> {/* [EDITED: KPI Task - Mahesh Sharma] */}
          <i className="bi bi-calendar3" style={{ color: '#16a34a', fontSize: size === 'sm' ? '0.9rem' : '1rem' }}></i> {/* [EDITED: KPI Task - Mahesh Sharma] */}
          <span className={`fw-medium text-truncate ${value ? 'text-dark' : 'text-muted'}`} style={{ fontSize: size === 'sm' ? '0.84rem' : '0.9rem' }}> {/* [EDITED: KPI Task - Mahesh Sharma] */}
            {displayText} {/* [EDITED: KPI Task - Mahesh Sharma] */}
          </span> {/* [EDITED: KPI Task - Mahesh Sharma] */}
        </div> {/* [EDITED: KPI Task - Mahesh Sharma] */}
        <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'} text-secondary ms-2`} style={{ fontSize: '0.75rem' }}></i> {/* [EDITED: KPI Task - Mahesh Sharma] */}
      </div>

      {/* Custom Calendar Popup (WITHOUT ISO Week Number Column) */}
      {isOpen && ( // [EDITED: KPI Task - Mahesh Sharma]
        <div // [EDITED: KPI Task - Mahesh Sharma]
          className="fy-calendar-popup shadow-lg" // [EDITED: KPI Task - Mahesh Sharma]
          style={{ // [EDITED: KPI Task - Mahesh Sharma]
            position: 'absolute', // [EDITED: KPI Task - Mahesh Sharma]
            top: 'calc(100% + 6px)', // [EDITED: KPI Task - Mahesh Sharma]
            left: 0, // [EDITED: KPI Task - Mahesh Sharma]
            zIndex: 1060, // [EDITED: KPI Task - Mahesh Sharma]
            backgroundColor: '#ffffff', // [EDITED: KPI Task - Mahesh Sharma]
            borderRadius: '10px', // [EDITED: KPI Task - Mahesh Sharma]
            border: '1px solid #e2e8f0', // [EDITED: KPI Task - Mahesh Sharma]
            padding: '14px', // [EDITED: KPI Task - Mahesh Sharma]
            width: '320px', // [EDITED: KPI Task - Mahesh Sharma]
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)' // [EDITED: KPI Task - Mahesh Sharma]
          }} // [EDITED: KPI Task - Mahesh Sharma]
        >
          {/* Calendar Header: Month/Year navigation */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}> {/* [EDITED: KPI Task - Mahesh Sharma] */}
            <button // [EDITED: KPI Task - Mahesh Sharma]
              type="button" // [EDITED: KPI Task - Mahesh Sharma]
              onClick={handlePrevMonth} // [EDITED: KPI Task - Mahesh Sharma]
              className="btn btn-sm btn-light border-0" // [EDITED: KPI Task - Mahesh Sharma]
              style={{ width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }} // [EDITED: KPI Task - Mahesh Sharma]
              title="Previous Month" // [EDITED: KPI Task - Mahesh Sharma]
            >
              <i className="bi bi-chevron-left text-dark"></i> {/* [EDITED: KPI Task - Mahesh Sharma] */}
            </button> {/* [EDITED: KPI Task - Mahesh Sharma] */}

            <div style={{ fontWeight: '700', fontSize: '0.95rem', color: '#1e293b' }}> {/* [EDITED: KPI Task - Mahesh Sharma] */}
              {viewDate.format('MMMM YYYY')} {/* [EDITED: KPI Task - Mahesh Sharma] */}
            </div> {/* [EDITED: KPI Task - Mahesh Sharma] */}

            <button // [EDITED: KPI Task - Mahesh Sharma]
              type="button" // [EDITED: KPI Task - Mahesh Sharma]
              onClick={handleNextMonth} // [EDITED: KPI Task - Mahesh Sharma]
              className="btn btn-sm btn-light border-0" // [EDITED: KPI Task - Mahesh Sharma]
              style={{ width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }} // [EDITED: KPI Task - Mahesh Sharma]
              title="Next Month" // [EDITED: KPI Task - Mahesh Sharma]
            >
              <i className="bi bi-chevron-right text-dark"></i> {/* [EDITED: KPI Task - Mahesh Sharma] */}
            </button> {/* [EDITED: KPI Task - Mahesh Sharma] */}
          </div> {/* [EDITED: KPI Task - Mahesh Sharma] */}

          {/* Day of Week Headers (7 columns only - No week numbers) */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', textAlign: 'center', marginBottom: '6px' }}> {/* [EDITED: KPI Task - Mahesh Sharma] */}
            {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => ( // [EDITED: KPI Task - Mahesh Sharma]
              <div key={day} style={{ fontSize: '0.75rem', fontWeight: '600', color: '#64748b', padding: '4px 0' }}> {/* [EDITED: KPI Task - Mahesh Sharma] */}
                {day} {/* [EDITED: KPI Task - Mahesh Sharma] */}
              </div> // [EDITED: KPI Task - Mahesh Sharma]
            ))} {/* [EDITED: KPI Task - Mahesh Sharma] */}
          </div> {/* [EDITED: KPI Task - Mahesh Sharma] */}

          {/* Calendar Weeks & Days Grid */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}> {/* [EDITED: KPI Task - Mahesh Sharma] */}
            {calendarWeeks.map((week) => { // [EDITED: KPI Task - Mahesh Sharma]
              const isSelected = currentSelectedIso === week.isoWeekCode; // [EDITED: KPI Task - Mahesh Sharma]
              const isHovered = hoveredWeek === week.isoWeekCode; // [EDITED: KPI Task - Mahesh Sharma]

              return ( // [EDITED: KPI Task - Mahesh Sharma]
                <div // [EDITED: KPI Task - Mahesh Sharma]
                  key={week.isoWeekCode} // [EDITED: KPI Task - Mahesh Sharma]
                  onClick={() => handleSelectWeek(week.isoWeekCode)} // [EDITED: KPI Task - Mahesh Sharma]
                  onMouseEnter={() => setHoveredWeek(week.isoWeekCode)} // [EDITED: KPI Task - Mahesh Sharma]
                  onMouseLeave={() => setHoveredWeek(null)} // [EDITED: KPI Task - Mahesh Sharma]
                  style={{ // [EDITED: KPI Task - Mahesh Sharma]
                    display: 'grid', // [EDITED: KPI Task - Mahesh Sharma]
                    gridTemplateColumns: 'repeat(7, 1fr)', // [EDITED: KPI Task - Mahesh Sharma]
                    cursor: 'pointer', // [EDITED: KPI Task - Mahesh Sharma]
                    borderRadius: '8px', // [EDITED: KPI Task - Mahesh Sharma]
                    backgroundColor: isSelected ? '#16a34a' : isHovered ? '#ecfdf5' : 'transparent', // [EDITED: KPI Task - Mahesh Sharma]
                    transition: 'all 0.12s ease-in-out', // [EDITED: KPI Task - Mahesh Sharma]
                    boxShadow: isSelected ? '0 2px 6px rgba(22, 163, 74, 0.35)' : 'none', // [EDITED: KPI Task - Mahesh Sharma]
                    border: isHovered && !isSelected ? '1px dashed #86efac' : '1px solid transparent' // [EDITED: KPI Task - Mahesh Sharma]
                  }} // [EDITED: KPI Task - Mahesh Sharma]
                  title={`Select week (${formatFYWeekLabel(week.isoWeekCode)})`} // [EDITED: KPI Task - Mahesh Sharma]
                >
                  {week.days.map((dayItem, dIdx) => ( // [EDITED: KPI Task - Mahesh Sharma]
                    <div // [EDITED: KPI Task - Mahesh Sharma]
                      key={dIdx} // [EDITED: KPI Task - Mahesh Sharma]
                      style={{ // [EDITED: KPI Task - Mahesh Sharma]
                        height: '32px', // [EDITED: KPI Task - Mahesh Sharma]
                        display: 'flex', // [EDITED: KPI Task - Mahesh Sharma]
                        alignItems: 'center', // [EDITED: KPI Task - Mahesh Sharma]
                        justifyContent: 'center', // [EDITED: KPI Task - Mahesh Sharma]
                        fontSize: '0.84rem', // [EDITED: KPI Task - Mahesh Sharma]
                        fontWeight: isSelected ? '700' : dayItem.isToday ? '700' : '500', // [EDITED: KPI Task - Mahesh Sharma]
                        color: isSelected // [EDITED: KPI Task - Mahesh Sharma]
                          ? '#ffffff' // [EDITED: KPI Task - Mahesh Sharma]
                          : !dayItem.isCurrentMonth // [EDITED: KPI Task - Mahesh Sharma]
                          ? '#94a3b8' // [EDITED: KPI Task - Mahesh Sharma]
                          : isHovered // [EDITED: KPI Task - Mahesh Sharma]
                          ? '#15803d' // [EDITED: KPI Task - Mahesh Sharma]
                          : '#1e293b', // [EDITED: KPI Task - Mahesh Sharma]
                        textDecoration: dayItem.isToday && !isSelected ? 'underline' : 'none' // [EDITED: KPI Task - Mahesh Sharma]
                      }} // [EDITED: KPI Task - Mahesh Sharma]
                    >
                      {dayItem.dayNumber} {/* [EDITED: KPI Task - Mahesh Sharma] */}
                    </div> // [EDITED: KPI Task - Mahesh Sharma]
                  ))} {/* [EDITED: KPI Task - Mahesh Sharma] */}
                </div> // [EDITED: KPI Task - Mahesh Sharma]
              ); // [EDITED: KPI Task - Mahesh Sharma]
            })} {/* [EDITED: KPI Task - Mahesh Sharma] */}
          </div> {/* [EDITED: KPI Task - Mahesh Sharma] */}

          {/* Quick Action Footer: Close */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '12px', paddingTop: '10px', borderTop: '1px solid #f1f5f9' }}> {/* [EDITED: KPI Task - Mahesh Sharma] */}
            <button // [EDITED: KPI Task - Mahesh Sharma]
              type="button" // [EDITED: KPI Task - Mahesh Sharma]
              onClick={() => setIsOpen(false)} // [EDITED: KPI Task - Mahesh Sharma]
              className="btn btn-sm btn-light py-1 px-4 border" // [EDITED: KPI Task - Mahesh Sharma]
              style={{ fontSize: '0.8rem', borderRadius: '5px', fontWeight: '500' }} // [EDITED: KPI Task - Mahesh Sharma]
            >
              Close {/* [EDITED: KPI Task - Mahesh Sharma] */}
            </button> {/* [EDITED: KPI Task - Mahesh Sharma] */}
          </div> {/* [EDITED: KPI Task - Mahesh Sharma] */}
        </div> // [EDITED: KPI Task - Mahesh Sharma]
      )}
    </div> // [EDITED: KPI Task - Mahesh Sharma]
  ); // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]
